import moment from 'moment'
import store from '../store'

const kmToMilesConversionRatio = 0.62137

export function getEventTargetName (e) {
    let targetName = e.nodeName.toLowerCase()

    e.classList.forEach((elem) => {
        targetName += `.${elem}`
    })

    return targetName
}

export function formatDate (date) {
    return moment(date).format('DD/MM/YYYY HH:mm:ss')
}

export function arrayToBitFlag (array, property) {
    if (property && array && Array.isArray(array)) {
        return array.reduce((acc, current) => acc + current[property], 0)
    } else if (array && Array.isArray(array)) {
        return array.reduce((acc, current) => acc + current, 0)
    } else {
        return 0
    }
}

export function bitFlagToArray (flag) {
    const byteArray = (flag >>> 0).toString(2).split('').reverse()
    return byteArray.map((val, index) => {
        return val * (Math.pow(2, index))
    }).filter(val => 0 !== val)
}

export function searchEnumById (data, id) {
    let value = data.find((enumObject) => {
        return enumObject.id === id
    })

    return null == value ? null : value.name ? value.name : value.key
}

export function splitCamelCase (word) {
    let output
    let i
    let l
    const capRe = /[A-Z]/

    if ('string' !== typeof (word)) {
        throw new Error('The "word" parameter must be a string.')
    }
    output = []
    for (i = 0, l = word.length; i < l; i += 1) {
        if (0 === i) {
            output.push(word[i].toUpperCase()
            )
        } else {
            if (0 < i && capRe.test(word[i])) {
                output.push(' ')
            }
            output.push(word[i])
        }
    }
    return output.join('')
}

export function normalizeData (array, key) {
    return array.reduce((data, item) => {
        data[item[key]] = item
        return data
    }, {})
}

export function camelCaseToSentence (str) {
    const result = str.replace(/([A-Z])/g, ' $1')
    return result.charAt(0).toUpperCase() + result.slice(1)
}

export function hexToRgb (hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) : null
}

export function deleteProperties (obj, propertyNames) {
    for (const propertyName of propertyNames) {
        if (obj.hasOwnProperty(propertyName)) {
            delete obj[propertyName]
        }
    }
}

export function flatArrayToNestedObj (array) {
    let idAsProperty = {}
    for (const organization of array) {
        idAsProperty[organization.id] = organization
    }
    let tree = array.reduce((a, e) => {
        a[e.id] = a[e.id] || e
        a[e.parentId] = a[e.parentId] || idAsProperty[e.parentId] || {}
        const parent = a[e.parentId]
        parent.fleets = parent.fleets || []
        parent.fleets.push(e)
        return a
    }, {})
    return Object.values(tree)
        .find(e => e.id === undefined).fleets
}

export function subtractSet (A, B) {
    return A.filter(x => !B.includes(x))
}

/**
 * Environment settings.
 * @param {Object, Array, String} payload
 */

export function appendRequestParameters (parameterName, request, payload, property) {
    if (Array.isArray(payload)) {
        payload.forEach(item => {
            request.append(parameterName, item[property])
        })
    } else if (payload.id) {
        request.append(parameterName, payload[property])
    } else {
        request.append(parameterName, payload)
    }
}

export function calculateSpeedOrDistanceUnit (speed, convertToUnit) {
    switch (convertToUnit) {
        case 'mi': return Math.round(speed * kmToMilesConversionRatio)
        case 'km': return Math.round(speed / kmToMilesConversionRatio)
    }
}

export function speedOrDistanceUnitManager (speed, type = null) {
    // 1 = miles, 0 = kilometers
    const speedUnit = store.getters['authModule/getSpeedUnit']
    let speedOrDistanceValue = speedUnit === 1 ? Math.round(speed * kmToMilesConversionRatio) : Math.round(speed);
    switch (speedUnit) {
        case 1: speedOrDistanceValue = Math.round(speed * kmToMilesConversionRatio)
            break;
        default: speedOrDistanceValue = Math.round(speed)
    }

    switch (type) {
        case 'speed': return `${speedOrDistanceValue} ${speedUnit === 1 ? 'mph' : 'kph'}`
        case 'distance': return `${speedOrDistanceValue} ${speedUnit === 1 ? 'mi' : 'km'}`
        default: return `${speedOrDistanceValue}`

    }
}

export function calculateMileage (mileage, convertToUnit) {
    switch (convertToUnit) {
        case 'mi': return parseFloat(mileage * kmToMilesConversionRatio).toFixed(2)
        case 'km': return parseFloat(mileage / kmToMilesConversionRatio).toFixed(2)
    }
}

export function JSONClone (data) {
    return JSON.parse(JSON.stringify(data))
}

export function findVehicleFromGroupedVehicles (vehicleId, response) {
    for (const organization of response.structure) {
        for (const fleet of organization.fleets) {
            for (const vehicle of fleet.vehicles) {
                if (vehicle.id === vehicleId) {
                    return vehicle
                }
            }
        }
    }
}
